<template>
  <div class="content">
    <div class="header">
      <v-layout row wrap align-center class="hero" :style="header()">
        <v-container fluid>
          <v-row>
            <v-col>
              <h2 class="display-2 text-center white--text pb-12">
                ABOUT
              </h2>
            </v-col>
          </v-row>
        </v-container>
      </v-layout>
    </div>

    <!-- FIXME: Modify this code so that the columns change on resizong. There was a bug prior so I used 2 spereate declarations and hid them on differnet sizes. (Same issue as home page)  -->
    <v-container>
      <v-row>
        <v-col cols="6" class="hidden-sm-and-down">
          <Title title="Angela Sette" subtitle="about" />
          <p class="pb-6">
            Angela Sette is a writer that taps into human potential stemming
            from our minds as well as our bodies. She is health Science
            educated, along with extensive experience as a mind-body movement
            specialist in Yoga, Pilates, Meditation and Dance. Angela had the
            privilege of working with high achievers, as well as those faced
            with physical and mental challenges. Striving to find medical
            answers to unattainable conventional methods for immediate family,
            especially her daughter, enabled her to discover and learn that
            which gives ultimate brain power and energy. Angela uniquely shares
            her scientific knowledge of the brain through authentic real life
            experiences to educate with the heart as well as the brain. Angela’s
            writing will enlighten, inspire and provoke the reader to look at
            life through a new evolutionary lens.
          </p>
        </v-col>
        <v-col cols="6" class="hidden-sm-and-down">
          <GeoImage />
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <Title title="Angela Sette" subtitle="about" />
          <p class="pb-6">
            Angela Sette is a writer that taps into human potential stemming
            from our minds as well as our bodies. She is health Science
            educated, along with extensive experience as a mind-body movement
            specialist in Yoga, Pilates, Meditation and Dance. Angela had the
            privilege of working with high achievers, as well as those faced
            with physical and mental challenges. Striving to find medical
            answers to unattainable conventional methods for immediate family,
            especially her daughter, enabled her to discover and learn that
            which gives ultimate brain power and energy. Angela uniquely shares
            her scientific knowledge of the brain through authentic real life
            experiences to educate with the heart as well as the brain. Angela’s
            writing will enlighten, inspire and provoke the reader to look at
            life through a new evolutionary lens.
          </p>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <GeoImage />
        </v-col>
      </v-row>
    </v-container>

    <Certs />
  </div>
</template>

<script>
import Certs from "../components/Certifications";
import Title from "../components/Title";
import GeoImage from "../components/GeoImage";

export default {
  components: {
    Certs,
    Title,
    GeoImage
  },
  data() {
    return {
      background: require("@/assets/background.jpg")
    };
  },
  methods: {
    header() {
      return {
        backgroundImage: `url(${this.background})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #fff;

  .header {
    height: 50vh;
  }
  .hero {
    height: 100%;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
}
</style>
